import {
    ITipsFeedbackApiItem,
    ITipsFeedbackItem,
    ITipsFeedbackResponse,
} from '../../interfaces/tips-feedback/ITipsFeedback';

// Billy endpoints may return the payload directly or in data / data.data.
export const unwrapFeedbackResponse = (response: unknown): unknown => {
    let payload = response;
    for (let depth = 0; depth < 2; depth += 1) {
        if (!payload || typeof payload !== 'object' || !('data' in payload)) break;
        payload = (payload as { data: unknown }).data;
    }
    return payload;
};

// Keep the dashboard's internal fields consistent across summary and detail
// payloads. The confirmed summary endpoint uses id/statusCode/status.
export const normalizeFeedbackItem = (item: ITipsFeedbackApiItem): ITipsFeedbackItem => ({
    ...item,
    _id: item.id || item._id || '',
    workflowStatus: item.statusCode || item.workflowStatus,
    investigation: item.leoFeedback ?? item.investigation,
    reason: item.cannotResolveReason ?? item.reason,
    resolution: item.resolution ?? undefined,
    ragParameter: item.ragParameter ?? undefined,
});

export const normalizeFeedbackDetails = (response: unknown): ITipsFeedbackItem =>
    normalizeFeedbackItem(unwrapFeedbackResponse(response) as ITipsFeedbackApiItem);

export const normalizeFeedbackList = (response: unknown): ITipsFeedbackResponse => {
    const payload = unwrapFeedbackResponse(response) as Omit<ITipsFeedbackResponse, 'elements'> & { elements?: ITipsFeedbackApiItem[] };
    return {
        ...payload,
        elements: (payload.elements || []).map(normalizeFeedbackItem),
    };
};
